"use client"

export const ContactHero = () => {
  return (
    <section className="relative bg-white border-b-8 border-amber-500 pt-24 pb-8 animate-in fade-in duration-700">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:py-16">
        <div className="text-center border-b-4 border-amber-800 pb-8 mb-10 animate-in slide-in-from-top duration-700">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-amber-600 rounded-full animate-pulse"></span>
            Travel Warehouse Inc. • Contact Us
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-gray-900 tracking-tight mb-4">Get in Touch</h1>
          <div className="text-lg sm:text-xl md:text-2xl text-gray-700 italic font-medium">We're Here to Help You Plan Your Journey</div>
        </div>

        <div className="border-l-4 border-orange-500 pl-6 sm:pl-8 max-w-4xl mx-auto animate-in slide-in-from-left duration-700" style={{ animationDelay: '200ms' }}>
          <p className="text-base sm:text-lg md:text-xl leading-relaxed text-gray-700">
            <span className="font-bold text-3xl float-left mr-3 leading-none text-orange-500">H</span> 
            ave questions about your next adventure? Our travel experts are ready to assist you with personalized
            recommendations and support. Reach out to us through any of the channels below, and we'll ensure your travel
            planning experience is smooth and enjoyable.
          </p>
        </div>
      </div>
    </section>
  )
}
